import React, { Component } from 'react'
import { connect } from 'react-redux'
import Infinite from 'react-infinite'

import {
  fetchAutomatedPolls,
  selectAutomatedPolls,
} from '../../stores/polls/automated'
import { hasMore } from '../../stores/cursoredUrlsStore'

import PollItem from './PollItem'

const ELEMENT_HEIGHT = 50

const renderLoading = () => (
  <div
    className="bg-white w-100 flex items-center ph3"
    style={{ height: ELEMENT_HEIGHT }}
  >
    Loading polls...
  </div>
)

const AutomationList = ({ polls, hasMore, fetchAutomatedPolls, loading }) => {
  return polls && polls.length ? (
    <Infinite
      useWindowAsScrollContainer={true}
      elementHeight={ELEMENT_HEIGHT}
      infiniteLoadBeginEdgeOffset={2000}
      onInfiniteLoad={hasMore ? fetchAutomatedPolls : () => {}}
      isInfiniteLoading={loading}
    >
      {polls.map(poll => (
        <PollItem
          elementHeight={ELEMENT_HEIGHT}
          key={poll.id}
          poll={poll}
          isAutomationTab={true}
        />
      ))}
    </Infinite>
  ) : null
}

class AutomationPollsList extends Component {
  componentDidMount() {
    if (!this.props.polls.length > 0) {
      this.props.fetchAutomatedPolls()
    }
  }

  render() {
    const { polls, loading, error, fetchAutomatedPolls, hasMore } = this.props

    return (
      <div>
        <div className="dt f6 w-100">
          <div className="word-wrap dt-row w-100 bg-op-con-dark white">
            <div className="dtc w-5 v-mid pa2">Type</div>
            <div className="dtc tl w-40 v-mid pa2">Question</div>
            <div className="dtc w-10 v-mid pa2">Publisher</div>
            <div className="dtc w-10 v-mid pa2">Last Updated</div>
            <div className="dtc w-10 v-mid pa2">Actions</div>
            <div className="dtc w-20 v-mid pa2 tr"></div>
          </div>
        </div>
        {loading && Object.keys(polls).length === 0 ? (
          renderLoading()
        ) : error ? (
          <div className="bg-white dark-red h3 flex items-center">
            <div
              className={`dib h-100 mr3 bg-dark-red`}
              style={{ width: '10px' }}
            ></div>
            <span>
              An error append while fetching featured polls:{' '}
              {JSON.stringify(error.toString(), null, 2)}
            </span>
          </div>
        ) : (
          <AutomationList
            polls={polls}
            hasMore={hasMore}
            fetchAutomatedPolls={fetchAutomatedPolls}
            loading={loading}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  polls: selectAutomatedPolls(state),
  loading: state.polls.automated.loading,
  error: state.polls.automated.error,
  hasMore: hasMore(state, 'automated-polls'),
})

const mapDispatchToProps = {
  fetchAutomatedPolls,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutomationPollsList)



// WEBPACK FOOTER //
// ./src/components/LibraryPage/AutomationPollsList.js